import { useEffect } from "react"

import CustodianMasterForm from "./CustodianMasterForm"


const CustodianMaster = ({ open }) => {
    useEffect(() => {
        document.title = 'Custodian Master'
    }, [])
    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <CustodianMasterForm />
        </main>
    )
}
export default CustodianMaster